export default {
    path: '',
    component: () => import(`@/component/admin-layout/index.vue`),
    children: [
        {
            path: '/admin/yinzhilv/demo-FlightFrequentTravelerSelector',
            name: 'admin-yinzhilv-demo-FlightFrequentTravelerSelector',
            component: () => import(`./index.vue`),
            meta: {
                entity_for_history_tag: {
                    name: `demo-FlightFrequentTravelerSelector`,
                },
                entity_list_for_breadcrumb: [
                    {name: `demo`},
                    {name: `demo-FlightFrequentTravelerSelector`},
                ],
                skip_check_token: true,
            },
        },
    ],
};
